import React, { Suspense, lazy } from "react";
import { createRoot } from "react-dom/client";
import { Route, Switch } from "react-router-dom";
import { ConnectedRouter } from "connected-react-router";
import { ToastContainer } from 'react-toastify';
import CookieConsent from "react-cookie-consent";
import Loader from './views/Loader';

import "assets/css/nucleo-icons.css";
import "react-notification-alert/dist/animate.css";
import "assets/scss/black-dashboard-pro-react.scss?v=1.2.0";
import "assets/demo/demo.css";

import { Provider } from 'react-redux';
import store, { history } from './redux/store/index';
import * as serviceWorker from './serviceWorker';
import {Helmet} from 'react-helmet';
import './i18n';

const AdminLayout = lazy(() => import("layouts/Admin/Admin.jsx"));
const HomeLayout = lazy(() => import("layouts/Admin/Home.jsx"));
const WikiLayout = lazy(() => import("layouts/Admin/Wiki.jsx"));
const TosLayout = lazy(() => import("layouts/Admin/Tos.jsx"));
const PrivacyLayout = lazy(() => import("layouts/Admin/Privacy.jsx"));

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <ConnectedRouter history={history} noTimeTravelDebugging>
      <Suspense fallback={<Loader />}>
        <img alt="" src="https://cdn-icons-png.flaticon.com/512/1801/1801901.png" onClick={() => window.open('https://discord.com/channels/856661122715484191/891431619964047480', '_blank')} className="callSupport"/>
        <Helmet>
          <title>RustLink ~ The best Rust+ Team Chat Discord Bot</title>
          <meta name="description" content="RustLink is a rust bot, with which you can control your smart switches, smart alarms, storage monitor. Track your storage, TCs upkeep, players. Monitor ingame events. Everything is customisable, and responsive."/>
          <meta name="keywords" content="Rust, Rust+, RustPlus, Rust Bot, RustLink, rust link, rust plus plus, rustplusplus, electricity"/>
        </Helmet>
        <ToastContainer theme="dark"/>
        <Switch>
          <Route path="/tos" component={TosLayout} />
          <Route path="/privacy" component={PrivacyLayout} />
          <Route path="/wiki" component={WikiLayout} />
          <Route path="/home" component={HomeLayout} />
          <Route path="/" component={AdminLayout} />
        </Switch>
        <CookieConsent style={{ background: "#29293a" }} buttonStyle={{ background: "#2676f6", color: "white" }}>This website uses cookies to enhance the user experience.</CookieConsent>
      </Suspense>
    </ConnectedRouter>
  </Provider>
);

serviceWorker.unregister();
